/**
 * @fileoverview GET handler for the "/engagement/invalid_attribute_names" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementInvalidAttributeNames } from "./constants";
import type { EngagementInvalidAttributeNamesResult, InvalidAttributeVariablesProps } from "./types";

export const getEngagementInvalidAttributeNames = reactQueryFetcherAdapter(
  engagementInvalidAttributeNames,
  (
    signal: AbortSignal,
    { customAttributes, contentBlocks }: InvalidAttributeVariablesProps
  ): Promise<EngagementInvalidAttributeNamesResult> => {
    return fetch(
      "/engagement/invalid_attribute_names",
      // this is a POST endpoint because the body can be huge, but it should be treated like a GET endpoint
      "POST",
      {
        custom_attribute_names: customAttributes,
        content_block_names: contentBlocks,
      },
      { signal }
    );
  }
);
